import {DDR} from './ddr.class';

export class DDRWoman3150Strategy extends DDR {
  constructor() {
    super([700, 5, 15, 75, 65, 1, 1, 14, 1.3, 400, 2.4, 5, 30, 425, 1000, 25, 900, 3, 150, 18, 320, 1.8, 700, 55, 8]);
  }
}
